import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, throwError, map, catchError } from 'rxjs';

@Injectable()
export class ExternalTemplateService {
  private http = inject(HttpClient);

  loadExternalHtml(queryString: string): Observable<string> {
    return this.http.get(queryString, { responseType: 'text' }).pipe(
      map((response) => {
        if (response) {
          return response;
        }
        throw new Error('Error fetching external template');
      }),
      catchError((err: unknown) => {
        return throwError(() => err);
      })
    );
  }
}
